import React from 'react';
import MDReportsListFilteredModule from '../modules/MDReportsListFilteredModule.js';
import './Box.css';

const MDReportsBox = ({ user, isSmallScreen }) => {
    return (
        <div className={isSmallScreen ? "standard-box-screen-small" : "standard-box"}>
            <h4></h4>
            <MDReportsListFilteredModule user={user} isSmallScreen={isSmallScreen} />
        </div>
    );
};

export default MDReportsBox;

